import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchButtonStyled } from '../../SearchButton';
import { ConnectedHotelStandaloneSearchFormDesktop } from '../HotelDesktop/HotelStandaloneSearchFormDesktop';
import { HSA_SEARCH_CLICK } from '../../../utils/HtmlEvents';
import { CarsSearchExtension } from '../../CarsSearchExtension';

const HotelTabManagerWithHotelStandalone = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="odf-space-inner-m">
                <div
                    className={`odf-flex-container-row odf-flex-container-nogutter odf-flex-container-align-stretch odf-space-inner-bottom-s`}
                >
                    <ConnectedHotelStandaloneSearchFormDesktop />
                </div>
                <div className="odf-flex-container-row odf-flex-container-nogutter odf-flex-container-align-stretch">
                    <div className="odf-flex-item">
                        <CarsSearchExtension tab="hotels" />
                    </div>
                    <div className="odf-flex-container-row odf-flex-item-sm odf-space-outer-right-l">
                        <div id="home_login_toggle" className="shell-integration_portal" />
                    </div>
                    <div className="odf-flex-item odf-flex-item-sm odf-flex-item-align-center">
                        <SearchButtonStyled
                            astId={window?.crypto?.randomUUID()}
                            hotelStandalone
                            testId="search-hotel-standalone-btn"
                            htmlEventID={HSA_SEARCH_CLICK}
                        >
                            {t('flightsManager.search.reduced')}
                        </SearchButtonStyled>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HotelTabManagerWithHotelStandalone;
